const { ELEMENT_NODE, TEXT_NODE } = Node;

export function simpleXmlToJson(node) {
    let result = {};

    if (node.nodeType === TEXT_NODE) {
        result = node.nodeValue;
    } else if (node.hasChildNodes()) {
        for (
            let i = 0,
                childNodes = node.childNodes,
                childNodeCount = childNodes.length;
            i < childNodeCount;
            i++
        ) {
            const childNode = childNodes.item(i);
            const childNodeName = childNode.nodeName;
            const childNodeType = childNode.nodeType;

            if (result.hasOwnProperty(childNodeName)) {
                if (!Array.isArray(result[childNodeName])) {
                    result[childNodeName] = [result[childNodeName]];
                }

                result[childNodeName].push(simpleXmlToJson(childNode));
            } else if (childNodeType === ELEMENT_NODE) {
                result[childNodeName] = simpleXmlToJson(childNode);
            } else {
                result = simpleXmlToJson(childNode);
            }
        }
    }

    return result;
}
